import Swiper, { Navigation, FreeMode, A11y } from 'swiper'
Swiper.use([Navigation, FreeMode, A11y])

export const swiperGallery = () => {

  const sliders = document.querySelectorAll('[data-swiper-cs]')

  if (!sliders.length) return

  sliders.forEach(slider => {

    const cursor = document.querySelector('.mf-cursor')
    const nextEl = slider.parentElement.querySelector('.next')
    const prevEl = slider.parentElement.querySelector('.prev')
    const countEl = slider.parentElement.querySelector('.count')

    const swiper = new Swiper(slider, {
      speed: 750,
      slidesPerView: 'auto',
      centeredSlides: true,
      freeMode: {
        enabled: true,
        momentum: true,
        sticky: true
      },
      navigation: {
        nextEl,
        prevEl 
      },
      on: {
        reachBeginning: function () { cursor.classList.remove('-prev') },
        reachEnd: function () { cursor.classList.remove('-next') },
      }
    })

    swiper.on('slideChange', (e) => countEl.innerHTML = e.realIndex + 1)

  })


}

export default () => {} 
